import { isValidPhoneNumber } from 'libphonenumber-js';

// Temporary fix for https://playosmo.atlassian.net/browse/PLAYOSMO-3033 :
const alternativeTelephoneRegex = /^\+(?:61[0-9]{9})$/;

export default function telephoneNumberValidator(value: string) {
  if (typeof value !== 'string') return false;

  let isValid = false;
  try {
    isValid = value && isValidPhoneNumber(value);
  } catch (err) {
    return false;
  }
  if (isValid) {
    return true;
  }

  return !!value.match(alternativeTelephoneRegex);
}
